/*
 * @Description: 
 * @Version: 2.0
 * @Autor: ShiChangZhan
 * @Date: 2021-08-27 12:41:37
 * @LastEditors: ShiChangZhan
 * @LastEditTime: 2021-09-09 14:24:48
 */
import { Toast } from 'vant'
export class CopyText {
  // Copy a string to user's clipboard
  copyToClipboard(text) {
    let copyText = document.createElement('input')
    document.body.appendChild(copyText)
    copyText.value = text
    copyText.select()
    document.execCommand('copy')
    document.body.removeChild(copyText)
    Toast('复制成功')
  }
}
//滚动容器,被滚动容器,滚动到底部要执行的方法
export const addListenScroll=(container,wrapper,fn)=>{
  // console.log('container',container,'wrapper',wrapper);
  //监听内容页面滚动
  container.addEventListener("scroll", (e) => {
    if(e.target.scrollTop == 0) {
      return
    }
    let bottomOfWindow =
      wrapper.offsetHeight -
      e.target.scrollTop -
      container.offsetHeight;
    bottomOfWindow = bottomOfWindow || 0;
    // console.log(bottomOfWindow);
    if (bottomOfWindow && bottomOfWindow <30) {
        fn()
    }
  });
}





// WEBPACK FOOTER //
// ./src/utils/utils.js